module.exports = __webpack_public_path__ + "media/images/emblems/Delley-Portalban-coat_of_arms-5480cae8b548bc36ce8d960c409c78ef.svg";